import { getAllUserDevice } from 'src/@api/login'
import { subscriptionRefreshed } from 'src/store/apps/Common'

const readDeviceUser = () => {
  try {
    return JSON.parse(localStorage.getItem('DeviceUser') || '{}') || {}
  } catch {
    return {}
  }
}

/**
 * 在设备列表里定位当前设备（先按 device_id，再按 iCloud_username）。
 * 供「需要按设备接口判定平台类型」的页面复用。
 * @param {Array} list - user-device 接口返回的设备数组
 * @param {Object} deviceUser - localStorage DeviceUser 对象
 * @returns {Object|null}
 */
export const matchCurrentDevice = (list, deviceUser) => {
  const devices = Array.isArray(list) ? list : []
  const deviceId = deviceUser?.device_id
  const username = deviceUser?.username

  if (deviceId != null && deviceId !== '') {
    const byId = devices.find(
      item => String(item.id) === String(deviceId) || String(item.device_id) === String(deviceId)
    )
    if (byId) return byId
  }

  if (username) {
    return devices.find(item => item.iCloud_username === username) || null
  }

  return null
}

/**
 * 续费 / 升级成功后无感刷新：
 * 1. 重拉设备列表写入 allDeviceUser
 * 2. 同步当前 DeviceUser.expire_time
 * 3. bump deviceSwitchRevision，驱动侧栏 / ExpiredMask 重算
 *
 * @param {Object} [params]
 * @param {import('redux').Dispatch} [params.dispatch]
 * @param {string} [params.expireTime] - 接口已返回的新到期时间，优先写入
 * @returns {Promise<{ ok: boolean, expireTime: string|null, device: Object|null }>}
 */
export const refreshSubscriptionExpire = async ({ dispatch, expireTime } = {}) => {
  if (typeof window === 'undefined') {
    return { ok: false, expireTime: null, device: null }
  }

  const prevDeviceUser = readDeviceUser()
  let devices = []

  try {
    const res = await getAllUserDevice({})
    devices = Array.isArray(res?.data) ? res.data : []
    localStorage.setItem('allDeviceUser', JSON.stringify(devices))
  } catch (e) {
    console.error('【refreshSubscriptionExpire】getAllUserDevice 失败', e)
  }

  const matched = matchCurrentDevice(devices, prevDeviceUser)
  const nextExpire =
    expireTime ||
    matched?.expire_time ||
    prevDeviceUser?.expire_time ||
    null

  const nextDeviceUser = {
    ...prevDeviceUser,
    ...(matched
      ? {
          username: matched.iCloud_username ?? prevDeviceUser.username,
          temporary: matched.temporary ?? prevDeviceUser.temporary,
          device_id: matched.id || matched.device_id || prevDeviceUser.device_id || '',
          order_id: matched.order_id ?? matched.orderId ?? prevDeviceUser.order_id ?? null,
          subscription_status: matched.subscription_status ?? prevDeviceUser.subscription_status ?? null
        }
      : {}),
    ...(nextExpire ? { expire_time: nextExpire } : {})
  }

  localStorage.setItem('DeviceUser', JSON.stringify(nextDeviceUser))

  if (typeof dispatch === 'function') {
    dispatch(subscriptionRefreshed())
  }

  return {
    ok: true,
    expireTime: nextExpire,
    device: matched
  }
}

/** 站内直接续费成功后延时整页刷新；软同步覆盖不全（banner / 遮罩仍可能停在已过期） */
export const RENEW_SUCCESS_REFRESH_DELAY = 1500

export const reloadAfterRenewSuccess = (delay = RENEW_SUCCESS_REFRESH_DELAY) => {
  if (typeof window === 'undefined') return
  window.setTimeout(() => window.location.reload(), delay)
}

export default refreshSubscriptionExpire
